export default "__VITE_ASSET__DO07qTvG__"